export const ENTITY_EXTRA_TAGS_ITEM_STATUS_COLORS = {
  error: {
    backgroundColor: 'var(--color-error-10)',
    textColor: 'var(--color-error)',
  },
  new: {
    backgroundColor: 'var(--color-info-10)',
    textColor: 'var(--color-info)',
  },
}
